import { useAtomValue, useSetAtom } from 'jotai';
import { agencyAtom } from '../../atoms';

export const useAgency = () => useAtomValue(agencyAtom);

export const useAgencyUpdater = () => useSetAtom(agencyAtom);
